module.exports = __webpack_public_path__ + "img/train.ddaa5d1f.svg";